import { Spinner, Title } from '@patternfly/react-core'
import * as React from 'react'
import { useEffect } from 'react'

import { useProgramStatistics } from '@app/domain/program/program.hooks'
import type { IProgram } from '@app/domain/program/program.interface'
import { StatusCard } from '@app/utils/summary-card'

interface Props {
  program: IProgram
}

export const ProgramStats = ({ program }: Props) => {
  const { statistics, isLoading, fetchStatistics } = useProgramStatistics()

  useEffect(() => {
    if (program?.programId) {
      fetchStatistics(program.programId)
    }
  }, [fetchStatistics, program])

  if (isLoading || !statistics) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Spinner size="sm" />
      </div>
    )
  }

  return (
    <>
      <Title headingLevel="h2" size="xl">
        Program Status
      </Title>

      <div style={{ display: 'flex', gap: '2rem' }}>
        <StatusCard
          value={statistics.enrolledPatients}
          subtitle="Enrolled Patients"
        />
        <StatusCard
          value={statistics.completedInteractions}
          subtitle="Interactions Done"
        />
      </div>
    </>
  )
}
